import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderMobile from './HeaderMobile';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { BASE_URL } from './Constants';

const Add_Stock_Apron = () => {
    const [stockRows, setStockRows] = useState([
        { type_id: '', size_id: '', color_id: '', quantity: '' }
    ]);
    const [dressTypes, setDressTypes] = useState([]);
    const [dressSizes, setDressSizes] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [areas, setAreas] = useState([]);
    const [dressColors, setDressColors] = useState([]);
    const [formError, setFormError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [gender, setGender] = useState('');
    const [gnrNumber, setGnrNumber] = useState('');
    const [gnrDate, setGnrDate] = useState('');
    const [image, setImage] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [stockType, setStockType] = useState('apron'); // 'normal' or 'apron'

    useEffect(() => {
            if (stockType.toLowerCase() === 'normal') {
                navigate('/add_stock');
            }
        }, [stockType, navigate]);

    // Fetch Dress Types
    useEffect(() => {
        const fetchDressTypes = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log(token);

                if (!token) {
                    setError('No token found!');
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${BASE_URL}dress_types`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                console.log('Fetched data:', data);

                if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
                    const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
                    setDressTypes(activeDressTypes);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchDressTypes();
    }, []);

    // const handleGenderChange = async (index, selectedGender) => {
    //     const updatedRows = [...stockRows];
    //     updatedRows[index].gender = selectedGender;

    //     const token = localStorage.getItem('authToken');
    //     const headers = {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${token}`,
    //     };

    //     try {
    //         const res = await fetch(`${BASE_URL}dress_types_by_gender`, {
    //             method: 'POST',
    //             headers,
    //             body: JSON.stringify({ gender: selectedGender }),
    //         });

    //         const data = await res.json();
    //         if (data.status && Array.isArray(data.dressTypes)) {
    //             updatedRows[index].typeOptions = data.dressTypes;

    //             // Reset dependent fields
    //             updatedRows[index].type_id = '';
    //             updatedRows[index].size_id = '';
    //             updatedRows[index].sizeOptions = [];
    //             updatedRows[index].color_id = '';
    //             updatedRows[index].colorOptions = [];
    //         } else {
    //             updatedRows[index].typeOptions = [];
    //         }

    //         setStockRows(updatedRows);
    //     } catch (err) {
    //         console.error('Error fetching dress types by gender:', err);
    //     }
    // };

    // Fetch Dress Sizes
    useEffect(() => {
        const fetchDressSizes = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    setError('No token found!');
                    setLoading(false);
                    return;
                }
                const response = await fetch(`${BASE_URL}areas`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });
                const data = await response.json();
                const activeSizes = (data.areas || []).filter(area => area.status === 'A');
                setAreas(activeSizes);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchDressSizes();
    }, []);

    // Add a new empty row
    const handleAddRow = () => {
        setStockRows([
            ...stockRows,
            { type_id: '', size_id: '', color_id: '', quantity: '' }
        ]);
    };

    // Remove a row
    const handleRemoveRow = (index) => {
        if (index === 0) {
            return;
        }
        const updatedRows = stockRows.filter((_, i) => i !== index);
        setStockRows(updatedRows);
    };

    // Handle input change per row
    const handleRowChange = async (index, e) => {
        const { name, value } = e.target;
        const updatedRows = [...stockRows];
        updatedRows[index][name] = value;

        const selectedGender = name === 'gender' ? value : updatedRows[index].gender;
        const selectedType = name === 'type_id' ? value : updatedRows[index].type_id;
        const selectedSize = name === 'size_id' ? value : updatedRows[index].size_id;
        
        console.log("check1", selectedGender);
        console.log("check2", selectedType);
        console.log("check3", selectedSize);
        
        const token = localStorage.getItem('authToken');
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        };

        // ✅ Fetch sizes only when type is changed
        if (name === 'type_id') {
            try {
                const resSize = await fetch(`${BASE_URL}dress_sizes_by_type`, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify({ type_id: value }),
                });

                const sizeData = await resSize.json();
                if (sizeData.status && Array.isArray(sizeData.dressTypes)) {
                    updatedRows[index].sizeOptions = sizeData.dressTypes;
                    updatedRows[index].size_id = '';
                    updatedRows[index].color_id = '';
                    updatedRows[index].colorOptions = [];
                } else {
                    updatedRows[index].sizeOptions = [];
                }
            } catch (err) {
                console.error('Error fetching sizes:', err);
            }
        }

        // ✅ Fetch colors only when size or type is changed
        if ((name === 'type_id' || name === 'size_id') && selectedSize) {
            try {
                const resColor = await fetch(`${BASE_URL}dress_colors_by_size`, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify({
                        dress_size_id: selectedSize,
                        dress_type_id: 5,
                        gender: 'Male',
                    }),
                });

                const colorData = await resColor.json();
                if (colorData.status && Array.isArray(colorData.dressTypes)) {
                    updatedRows[index].colorOptions = colorData.dressTypes;

                    // Only reset if selected color is not in the new list
                    const colorStillExists = colorData.dressTypes.some(color => color.id === updatedRows[index].color_id);
                    if (!colorStillExists) {
                        updatedRows[index].color_id = '';
                    }
                } else {
                    updatedRows[index].colorOptions = [];
                }
            } catch (err) {
                console.error('Error fetching dress colors:', err);
            }
        }

        setStockRows(updatedRows);
    };

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);

        // Check for empty fields
        for (const row of stockRows) {
            if (!row.size_id || !row.color_id || !row.quantity) {
                setFormError('All fields are required for every row.');
                return;
            }
        }

        try {
            const token = localStorage.getItem('authToken');
            const formData = new FormData();

            // Loop through stock rows and append each row's data
            stockRows.forEach((row, index) => {
                formData.append(`area_id[${index}]`, row.area_id);
                formData.append(`type_id[${index}]`, 5);
                formData.append(`gender[${index}]`, 'Male');
                formData.append(`size_id[${index}]`, row.size_id);
                formData.append(`color_id[${index}]`, row.color_id);
                formData.append(`quantity[${index}]`, row.quantity);
            });
            formData.append('gnr_date', gnrDate);
            formData.append('gnr_number', gnrNumber);
        //    formData.append('stock_type', stockType); // Add stock type to form data
            if (image) {
                formData.append('image', image);
            }

            // Sending all rows data in one request
            const response = await fetch(`${BASE_URL}add_stock_apron`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to add stock entries');
            }

            // Redirect after successful submission
            navigate('/manage_stocks');
        } catch (err) {
            setFormError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    const handleBackClick = () => {
        navigate("/manage_stocks");
    };

    const handleToggleSidebar = () => {
        if (window.innerWidth >= 992) {
            setIsSidebarOpen(prev => !prev);
        }
    };

    return (
        <div className="page-wrapper">
            <HeaderMobile />
            <Sidebar isOpen={isSidebarOpen} />
            <div className="page-container" style={{
                marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
                transition: 'margin-left 0.3s ease',
            }}>
                <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div className="main-content">
                    <div className="section__content section__content--p30">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card add-user-card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h2 className="mb-0">Add Stock</h2>
                                                <div className="stock-type-radios">
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="stockType"
                                                            id="normalStock"
                                                            value="normal"
                                                            checked={stockType === 'normal'}
                                                            onChange={(e) => setStockType(e.target.value)}
                                                        />
                                                        <label className="form-check-label" htmlFor="normalStock">
                                                            Normal
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="stockType"
                                                            id="apronStock"
                                                            value="apron"
                                                            checked={stockType === 'apron'}
                                                            onChange={(e) => setStockType(e.target.value)}
                                                        />
                                                        <label className="form-check-label" htmlFor="apronStock">
                                                            Apron
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
                                                {formError && <div className="alert alert-danger">{formError}</div>}
                                                {error && <div className="alert alert-danger">{error}</div>}
                                                {loading && <div className="alert alert-info">Loading data...</div>}

                                                {stockRows.map((row, index) => (
                                                    <div className="form-row mb-3" key={index}>
                                                        <div className="form-group col-md-2">
                                                            {index === 0 && <label>Area</label>}
                                                            <select
                                                                name="area_id"
                                                                className="form-control"
                                                                value={row.area_id}
                                                                onChange={(e) => handleRowChange(index, e)}
                                                                required
                                                            >
                                                                <option value="">Select Area</option>
                                                                {areas.map((area) => (
                                                                    <option key={area.id} value={area.id}>{area.area}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* <div className='form-group col-md-2'>
                                                            {index === 0 && <label>Gender</label>}
                                                            <select
                                                                name="gender"
                                                                value={row.gender || ''}
                                                                onChange={(e) => handleGenderChange(index, e.target.value)}
                                                                className="form-control"
                                                                required
                                                            >
                                                                <option value="">Select Gender</option>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                            </select>
                                                        </div> */}

                                                        <div className="form-group col-md-2">
                                                            {index === 0 && <label>Type</label>}
                                                            <select
                                                                name="type_id"
                                                                className="form-control"
                                                                value={5}
                                                                onChange={(e) => handleRowChange(index, e)}
                                                                required
                                                            >
                                                                <option value="5">Apron</option>
                                                               
                                                            </select>
                                                        </div>
                                                        <div className="form-group col-md-2">
                                                            {index === 0 && <label>Size</label>}
                                                            <select
                                                                name="size_id"
                                                                className="form-control"
                                                                value={row.size_id}
                                                                onChange={(e) => handleRowChange(index, e)}
                                                                required
                                                            >
                                                                <option value="">Select Size</option>
                                                                <option value="35">Small</option>
                                                                <option value="36">Medium</option>
                                                                <option value="37">Large</option>
                                                                <option value="38">XL</option>
                                                                <option value="61">Xs</option>
                                                               
                                                            </select>
                                                        </div>
                                                        <div className="form-group col-md-2">
                                                            {index === 0 && <label>Color</label>}
                                                            <select
                                                                name="color_id"
                                                                className="form-control"
                                                                value={row.color_id}
                                                                onChange={(e) => handleRowChange(index, e)}
                                                                required
                                                            >
                                                                <option value="">Select Color</option>
                                                                {row.colorOptions?.map((color) => (
                                                                    <option key={color.id} value={color.id}>{color.dress_color}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="form-group col-md-1">
                                                            {index === 0 && <label>Quantity</label>}
                                                            <input
                                                                type="number"
                                                                name="quantity"
                                                                className="form-control"
                                                                value={row.quantity}
                                                                onChange={(e) => handleRowChange(index, e)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-md-1" style={{ padding: '0px 9px 9px 13px' }}>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={() => handleRemoveRow(index)}
                                                            >
                                                                x
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}

                                                <div className="form-row mb-3">
                                                    <div className="form-group col-md-4">
                                                        <label>GNR Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={gnrDate}
                                                            onChange={(e) => setGnrDate(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>GRN Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={gnrNumber}
                                                            onChange={(e) => setGnrNumber(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Upload Image</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={(e) => setImage(e.target.files[0])}
                                                            
                                                        />
                                                    </div>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mb-3 add-row-btn"
                                                    onClick={handleAddRow}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-10px',
                                                        right: '10px',
                                                        zIndex: '10',
                                                    }}
                                                >
                                                    +
                                                </button>

                                                <div className="d-flex justify-content-between">
                                                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                                                        {submitting ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={handleBackClick}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default Add_Stock_Apron;